import { GroundTransportDetailApp } from "groundTransport/detail/app";
import GroundTransportListApp from "groundTransport/list/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const groundTransportRoute: RouteObject = {
  path: "groundtransport",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: GroundTransportListApp,
  }, {
    path: "detail/:key",
    loader: () => viewModel,
    Component: GroundTransportDetailApp,
  }]
};